import React, { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import { edWebkitTheme } from "@trailblazer-game/ed-webkit";

//
export default function LoginTextInput(props: any) {

    let [ type, setType ] = useState("");

    useEffect(() => {
        if (props.type === 'password') {
            setType('password');
        }
    }, [])

    //
    return (
        <TextField
            onChange={props.onChange}
            value={props.value}
            sx={{
                color: "red",
                width: "100%",
                flexGrow: "1",
                ".MuiInputBase-root": {
                    background: edWebkitTheme.palette.grey['900'],
                    color: "white",
                    padding: '0px',
                    ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d4a545!important",
                        borderWidth: "1px!important"
                    }
                },
                ".MuiFormLabel-root": {
                    color: "#33466b",
                    "&.Mui-focused": {
                        color: "#33466b!important",
                        borderColor: "#d4a545!important",
                        borderWidth: "1px!important"
                    }
                },
                ".MuiInputBase-input": { padding: "10px 10px 10px 10px!important" }

            }}
            onKeyDown={props.onKeyDown}
            type={type}
            id="outlined-basic"
            label={props.label}
            variant="outlined"/>
    )
}